import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58d54798"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "campaign"
}
const _hoisted_2 = { class: "p-grid p-flex-wrap p-justify-between" }
const _hoisted_3 = { class: "p-grid p-col-11 p-m-auto" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "p-d-flex p-flex-column" }
const _hoisted_6 = { class: "p-mb-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Brand", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-col-11 p-m-auto" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "p-mt-6" }, "brand description")
], -1))
const _hoisted_9 = { class: "p-grid p-col-11 p-m-auto" }
const _hoisted_10 = {
  key: 0,
  class: "default-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_shortCampaignPage = _resolveComponent("shortCampaignPage")!
  const _component_app_page = _resolveComponent("app-page")!

  return (_openBlock(), _createBlock(_component_app_page, {
    onPublishCampaign: _ctx.publishCampaign,
    config: _ctx.config,
    type: _ctx.campaign?.status,
    publishWithMenu: true,
    title: _ctx.campaign?.name,
    class: "bac_image",
    style: _normalizeStyle(`--my-src: url(${_ctx.campaign?.photo})`)
  }, {
    default: _withCtx(() => [
      (_ctx.campaign)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("section", _hoisted_2, [
              _createVNode(_component_shortCampaignPage, {
                class: "p-grid p-col-11 p-m-auto",
                campaignInfo: _ctx.campaign,
                "short-preview": false
              }, null, 8, ["campaignInfo"]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: [_ctx.campaign.brand.photo && _ctx.campaign.brand.photo.trim() !== '' ?
             _ctx.campaign.brand?.photo : require('@/assets/images/brand/brand-default.svg')],
                  class: "p-mr-6 brand-photo"
                }, null, 8, _hoisted_4),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.campaign?.brand?.name), 1),
                  _hoisted_7
                ])
              ]),
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                (_ctx.campaign.brand && _ctx.campaign.brand.description)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.campaign.brand.description), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onPublishCampaign", "config", "type", "title", "style"]))
}